<template>
    <div>
      <v-row row wrap class="text-center">
        <v-col :cols="12">
          <el-select
            size="small"
            v-model="selectedShopId"
            filterable
            multiple
            placeholder="เลือกร้าน"
            class="mr-2"
            collapse-tags
            style="width: 300px"
          >
            <el-option
              v-for="item in shopList"
              :key="item.shop_id"
              :label="item.name"
              :value="item.shop_id"
            ></el-option>
          </el-select>
  
          <el-date-picker
            size="small"
            v-model="daterange"
            type="daterange"
            value-format="yyyy-MM-dd"
            format="dd/MM/yyyy"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
          ></el-date-picker>
          <el-button type="primary" class="ml-2" size="mini" @click="viewReport"
            >ค้นหา</el-button
          >
          <el-button type="success" class="ml-2" size="mini" @click="downloadReport"
            ><i class="fas fa-file-download"></i> ดาวน์โหลด</el-button
          >
        </v-col>
      </v-row>
  
      <!-- <v-row class="my-5" v-if="showStat">
        <v-col :cols="12" class="pr-0">
          <el-card class="box-card mx-3">
            <v-row>
              <v-col class="text-center">
                <strong>ยอดขาย</strong>
                <br />
                <h4 class="mt-2">฿ {{ amount.revenue | numFormat("0,0.00") }}</h4>
              </v-col>
              <v-divider class="mx-4" vertical></v-divider>
              <v-col class="text-center">
                <strong>ธรรมเนียมการชำระเงิน</strong>
                <br />
                <h4 class="mt-2">฿ {{ amount.fee | numFormat("0,0.00") }}</h4>
              </v-col>
              <v-divider class="mx-4" vertical></v-divider>
              <v-col class="text-center">
                <strong>จำนวนบิล</strong>
                <br />
                <h4 class="mt-2">
                  {{ amount.count_rows | numFormat("0,0") }}
                </h4>
              </v-col>
            </v-row>
          </el-card>
        </v-col>
      </v-row> -->
      <el-card class="mt-3 mx-3 mb-5">
        <!-- <div slot="header" class="clearfix">
          <span>&nbsp;</span>
          <el-button
            icon="fas fa-file-download"
            v-if="orderList.length > 0"
            style="float: right; padding: 3px 0"
            type="text"
            @click="downloadReport"
            >&nbsp;ดาวน์โหลด</el-button
          >
        </div> -->
  
        <v-data-table
          :headers="headers"
          :items="orderList"
          :loading="isLoading"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :mobile-breakpoint="`10`"
          @page-count="pageCount = $event"
          hide-default-footer
          class="elevation-0 rounded-table"
        >
          <template v-slot:no-data>
            <div class="text-center">
              <img src="@/assets/img/no-order.png" style="width: 30%" />
            </div>
          </template>
  
          <template v-slot:item.order_reference="{ item }">
            <div style="min-height: 60px; width: 140px">
              <div class="pt-3">
                <el-tooltip
                  content="เดลิเวอรี่"
                  placement="top"
                  v-if="item.order_type == 'delivery'"
                >
                  <i class="fas fa-motorcycle mr-2"></i>
                </el-tooltip>
                <el-tooltip
                  content="คอมเมิร์ซ"
                  placement="top"
                  v-if="item.order_type == 'commerce'"
                >
                  <i class="fas fa-shopping-bag mr-2"></i>
                </el-tooltip>
                <el-tooltip
                  content="รับเองที่ร้าน"
                  placement="top"
                  v-if="item.order_type == 'pickup'"
                >
                  <i class="fas fa-store mr-2"></i>
                </el-tooltip>
  
                <el-tooltip
                  content="สั่งจาก POS"
                  placement="top"
                  v-if="['dinein', 'dinein-buffet'].includes(item.order_type)"
                >
                  <i class="fas fa-desktop mr-2"></i>
                </el-tooltip>
  
                <span class="grey--text">{{ item.order_reference }}</span>
              </div>
            </div>
              
          </template>


          <template v-slot:item.status="{ item }">
            {{ item.status }}
          </template>
  
          <template v-slot:item.shop_name="{ item }">
            <div style="width: 200px">
              <strong>{{ item.shop_name }}</strong>
            </div>
          </template>
  
          <template v-slot:item.date="{ item }">
            <div style="width: 150px">
              <div>{{ item.date | moment("DD/MM/YYYY HH:mm") }}</div>
            </div>
          </template>
  
          <template v-slot:item.customer_name="{ item }">
            <div style="width: 120px">
              <strong>{{ item.customer_name }}</strong>
            </div>
          </template>
  
          <template v-slot:item.customer_mobile="{ item }">
            <div style="width: 120px">
              <span>
                <i class="fas fa-mobile-alt"></i>
                {{ item.customer_mobile }}
              </span>
            </div>
          </template>
  
          <template v-slot:item.payment_type="{ item }">
            <div>
              <el-tag size="small" type="info">{{ item.payment_type }}</el-tag>
            </div>
          </template>
  
          <template v-slot:item.sattlement_amount="{ item }">
            <div>
              <strong>฿ {{ item.sattlement_amount | numFormat("0,0.00") }}</strong>
            </div>
          </template>
  
          <template v-slot:item.payment_fee="{ item }">
            <div>
              <strong>฿ {{ item.payment_fee | numFormat("0,0.00") }}</strong>
            </div>
          </template>
  
          <template v-slot:item.net_amount="{ item }">
            <div>
              <strong class="green--text">฿ {{ item.net_amount | numFormat("0,0.00") }}</strong>
            </div>
          </template>
  
          <template v-slot:item.sattlement_at="{ item }">
            <div style="width: 150px">
              <div>{{ item.sattlement_at | moment("DD/MM/YYYY HH:mm") }}</div>
            </div>
          </template>
        </v-data-table>
  
        <div
          style="
            position: fixed;
            bottom: 10px;
            right: 10px;
            z-index: 9;
            width: 100%;
          "
        >
          <v-pagination
            circle
            v-model="page"
            :total-visible="5"
            :length="pageCount"
          ></v-pagination>
        </div>
      </el-card>
  
      <payment-dialog
        :showDialog="paymentInfoDialog"
        :order="selectedOrder"
        @close="paymentInfoDialog = false"
      ></payment-dialog>
    </div>
  </template>
<script>
import Service from "@/services";
import moment from "moment";
import * as XLSX from "xlsx";

import PaymentDialog from "@/components/PaymentDialog";
  export default {
    components: {
      PaymentDialog,
    },
    props: {
      shop: { default: false },
      showStat: { default: false },
      gp: { default: false },
    },
    data() {
      return {
        mode: null,
        loading: null,
        isLoading: false,
        daterange: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")],
        selectedShopId: null,
        orderList: [],
        selectedOrder: null,
        page: 1,
        itemsPerPage: 25,
        pageCount: 0,
        amount: {
          revenue: 0,
          fee: 0,
          count_rows: 0,
        },
        permission: null,
        shopList: [],
        headers: [
          {
            text: "#",
            align: "left",
            sortable: false,
            value: "order_reference",
          },
          { text: "สถานะ", value: "status", sortable: false },
          { text: "ร้าน", value: "shop_name", sortable: false },
          { text: "วันที่", value: "date", sortable: false },
          { text: "ลูกค้า", value: "customer_name", sortable: false },
          { text: "เบอร์โทร", value: "customer_mobile", sortable: false },
          { text: "การชำระ", value: "payment_type", sortable: false },
          { text: "ยอดชำระชำระเงิน", value: "sattlement_amount", sortable: false, width: "170px" },
          { text: "ค่าธรรมเนียม", value: "payment_fee", sortable: false, width: "130px" },
          { text: "ยอดสุทธิ", value: "net_amount", sortable: false, width: "130px" },
          { text: "Gateway Partner", value: "gateway_partner", sortable: false, width: "130px" },
          { text: "Gateway Reference", value: "external_reference", sortable: false, width: "130px" },

        //   { text: "วันที่ชำระ", value: "sattlement_at", sortable: false },
        ],
        statusOrdering: [
          "pending",
          "new",
          "acccepted",
          "cooking",
          "processing",
          "completed",
          "cancelled",
        ],
        paymentInfoDialog: false,
      };
    },
    created() {
      Service.User.permission().then((resp) => {
        this.permission = resp.data;
        this.mode = this.permission.user.role_id;
  
        Service.Shop.gets().then((res) => {
          /*
          this.shopList = res.data.filter(function(item) {
            return item.status == "published";
          });
          */
          this.shopList = res.data;
  
          this.shopList.sort(function(a, b) {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          });
          /*
          this.shopList = this.shopList.filter(item => {
            return item.ent_id == this.permission.enterprises[0].ent_id;
          });
          */
        });
      });
    },
    methods: {
      openItem(item) {
        if (
          item.order_type == "delivery" ||
          item.order_type == "pickup" ||
          item.order_type == "dinein" ||
          item.order_type == "dinein-buffet"
        ) {
          //this.$router.push("/orders/" + item.order_reference + "/view");
  
          window
            .open("/orders/" + item.order_reference + "/view", "_blank")
            .focus();
        } else if (item.order_type == "commerce") {
          //this.$router.push("/commerce/view/order/" + item.order_reference);
          window
            .open("/commerce/view/order/" + item.order_reference, "_blank")
            .focus();
        }
      },
      viewReport() {
        this.showLoading();
  
        let params = {
          begin: this.daterange[0],
          end: this.daterange[1],
          report: true,
          type: "view",
          per_page:1000
          // order_type: "delivery,pickup",
        };
  
        if (this.selectedShopId != null) {
          params.shop_ids = this.selectedShopId;
        }
        this.amount = {
          revenue: 0,
          fee: 0,
          count_rows: 0,
        };

        if(params.shop_ids && params.shop_ids.length < 1){
            delete params.shop_ids;
        }
        Service.Report.saleReport2025(params).then((res) => {
          this.orderList = res.data.rows;
  
          this.orderList.sort(
            (a, b) =>
              this.statusOrdering.indexOf(a.status) -
              this.statusOrdering.indexOf(b.status)
          );
  
          if (res.data.stats) {
            this.amount.revenue = res.data.stats.total || 0;
            this.amount.fee = res.data.stats.fee || 0;
            this.amount.count_rows = res.data.stats.count_rows || 0;
          }
  
          // this.orderList.map((item) => {
          //   if (!["cancelled", "deleted", "pending"].includes(item.order_status)) {
          //     this.amount.revenue += parseFloat(item.amount.total);
          //     this.amount.delivery += parseFloat(item.amount.delivery);
          //     this.amount.delivery_tax += parseFloat(item.amount.delivery_tax);
          //     this.amount.food += parseFloat(item.amount.food);
          //     this.amount.extra += parseFloat(item.amount.extra);
          //     this.amount.discount += parseFloat(item.amount.discount);
          //     this.amount.completed++;
  
          //     let cog = 0;
  
          //     if (
          //       item.order_basket.product_list != null &&
          //       item.order_basket.product_list.length > 0
          //     ) {
          //       item.order_basket.product_list.map((product) => {
          //         cog += parseInt(product.cog) * product.quantity;
          //         this.amount.quantity += product.quantity;
          //       });
          //     }
          //     item.amount.cog = cog;
          //     this.amount.cog += item.amount.cog;
          //     if (item.driver_info_json != null) {
          //       this.amount.lalamove +=
          //         parseFloat(item.amount.delivery) +
          //         parseFloat(item.amount.delivery_tax);
          //     }
          //   }
          // });
  
          this.hideLoading();
        });
      },
      downloadReport() {
        this.showLoading();

        let params = {
          begin: this.daterange[0],
          end: this.daterange[1],
          report: true,
          type: "view",
          per_page: 1000
        };

        if (this.selectedShopId != null) {
          params.shop_ids = this.selectedShopId;
        }

        if (params.shop_ids && params.shop_ids.length < 1) {
          delete params.shop_ids;
        }

        Service.Report.saleReport2025(params).then((res) => {
          const rows = res.data.rows;

          // สร้างข้อมูลสำหรับ Excel
          const excelData = rows.map((item) => {
            return {
              "#": item.order_reference,
              "สถานะ": item.status,
              "ร้าน": item.shop_name,
              "วันที่": moment(item.date).format("DD/MM/YYYY HH:mm"),
              "ลูกค้า": item.customer_name,
              "เบอร์โทร": item.customer_mobile,
              "การชำระ": item.payment_type,
              "ยอดชำระเงิน": parseFloat(item.sattlement_amount),
              "ค่าธรรมเนียม": parseFloat(item.payment_fee),
              "ยอดสุทธิ": parseFloat(item.net_amount)
            };
          });

          // สร้าง worksheet และ workbook
          const ws = XLSX.utils.json_to_sheet(excelData);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "รายงานการขาย");

          // กำหนดชื่อไฟล์
          const fileName = `รายงานการขาย_${this.daterange[0]}_${this.daterange[1]}.xlsx`;

          // ดาวน์โหลดไฟล์
          XLSX.writeFile(wb, fileName);

          this.hideLoading();
        }).catch((error) => {
          console.error("Error downloading report:", error);
          this.hideLoading();
          this.$swal({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: "ไม่สามารถดาวน์โหลดรายงานได้",
          });
        });
      },
      showLoading() {
        this.loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.7)",
        });
      },
      hideLoading() {
        this.loading.close();
      },
      openPaymentInfo(item) {
        this.selectedOrder = item;
        this.paymentInfoDialog = true;
      },
    },
  };
  </script>
  <style scoped>
  .rounded-table {
    border-radius: 12px;
    overflow: hidden;
  }
  
  .rounded-table >>> .v-data-table {
    border-radius: 12px;
  }
  
  .rounded-table >>> table {
    border-radius: 12px;
    overflow: hidden;
  }
  
  .rounded-table >>> thead {
    background-color: #f5f7fa;
  }
  
  .rounded-table >>> thead th {
    font-weight: 600;
    color: #303133;
  }
  
  .rounded-table >>> tbody tr:hover {
    background-color: #f5f7fa;
  }
  
  .rounded-table >>> tbody tr:last-child td:first-child {
    border-bottom-left-radius: 12px;
  }
  
  .rounded-table >>> tbody tr:last-child td:last-child {
    border-bottom-right-radius: 12px;
  }
  
  .badge-status {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 11px;
    margin-top: 4px;
    color: white;
    font-weight: 500;
  }
  </style>
  